import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';

import styles from '../assets/styles/main.scss'

import { fetchUserProfile } from '../actions/currentUser';
import { fetchOrganisations } from '../actions/organisations';

import NotFound from './pages/NotFound';
import Login from './pages/Login';
import Organisations from './pages/Organisations';
import Organisation from './pages/Organisation';
import Profiles from './pages/Profiles';
import Visual from './pages/Visual';
import Events from './pages/Events';

class App extends Component {

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(fetchUserProfile());
    dispatch(fetchOrganisations());
  }

  render() {
    const { match } = this.props;

    return (
      <Switch>
        <Route exact path="/">
          <Redirect to="/organisations" />
        </Route>

        <Route exact path="/organisations" component={Organisations} />

        <Route path="/organisations/:organisationId/" component={Organisation} />

        <Route component={NotFound} />
      </Switch>
    )
  }
}

export default withRouter(connect()(App));



// WEBPACK FOOTER //
// ./src/components/App.js